import { render, staticRenderFns } from "./SkillNameAdd.vue?vue&type=template&id=f6b9408c&"
import script from "./SkillNameAdd.vue?vue&type=script&lang=js&"
export * from "./SkillNameAdd.vue?vue&type=script&lang=js&"
import style0 from "./SkillNameAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports